// extracted by mini-css-extract-plugin
export default {"settingsDetail":"SettingsDetail_settingsDetail__wCfth","carousel_item":"SettingsDetail_carousel_item__1ps2q","carousel_title":"SettingsDetail_carousel_title__J1mJQ"};